<div class="background-color">
  <h1 mat-dialog-title>
    {{ "medicalHistory.modify.prescriptionHex.title" | translate }}
  </h1>
  <div mat-dialog-content class="content">
    @if (!showPrescriptionValidation) {
      <div>
        {{
          "medicalHistory.modify.prescriptionHex.confirmationMessage"
            | translate
        }}
      </div>
    }

    @if (showPrescriptionValidation) {
      <div
        [formGroup]="formGroup"
        [class.hide-item]="currentPage !== pages.prescriptionData"
      >
        <div class="dialog-content">
          <mat-accordion
            #accordion="matAccordion"
            class="full-width"
            [multi]="true"
          >
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="flex-grow-0" id="pnlMasterData">
                  <strong>{{
                    "medicalHistory.modify.prescriptionHex.coreData" | translate
                  }}</strong>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column overflow-auto">
                <div class="d-flex gap-12-em">
                  <div class="d-flex flex-column">
                    <span class="title">
                      {{
                        "medicalHistory.modify.prescriptionHex.uidNumber"
                          | translate
                      }}
                    </span>
                    @if (firm && firm.uidNr) {
                      <span class="font-weight-500" id="spnUidFirm">
                        {{ firm.uidNr }}
                      </span>
                    }
                  </div>
                  <div class="d-flex flex-column">
                    <span class="title">
                      {{
                        "medicalHistory.modify.prescriptionHex.addition"
                          | translate
                      }}
                    </span>
                    @if (selectedDepartment) {
                      <span class="font-weight-500" id="spnDepartmentIsabv">
                        {{ selectedDepartment.isabvAddition }}
                      </span>
                    }
                  </div>
                  <div class="d-flex flex-column">
                    <span class="title">
                      {{
                        "medicalHistory.modify.prescriptionHex.addressOfPractice"
                          | translate
                      }}
                    </span>
                    @if (firm) {
                      <span class="font-weight-500" id="spnFirmAddress">
                        {{
                          selectedDepartment?.isabvAddress ||
                            firm.street +
                              " " +
                              firm.postalCode +
                              "
                        " +
                              firm.city
                        }}
                      </span>
                    }
                  </div>
                </div>
                <div class="d-flex margin-bottom-10 padding-top-10 gap-5-em">
                  <div class="d-flex flex-column">
                    <span class="title">
                      {{
                        "medicalHistory.modify.prescriptionHex.customerAddress"
                          | translate
                      }}
                    </span>
                    @if (params.customerAddress) {
                      <span class="font-weight-500" id="spnCustomerAddress">
                        {{ params.customerAddress }}
                      </span>
                    }
                  </div>
                  <div class="d-flex flex-column">
                    <span class="title">
                      {{
                        "medicalHistory.modify.prescriptionHex.tvdNumberCustomer"
                          | translate
                      }}
                    </span>
                    @if (params.customerTvdNr) {
                      <span class="font-weight-500" id="spnCustomerTvdNr">
                        {{ params.customerTvdNr }}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="true">
              <div class="d-flex flex-column padding-top-10">
                <div class="d-flex gap-10 overflow-auto">
                  <div class="d-flex flex-column">
                    <span class="title">
                      {{
                        "medicalHistory.modify.prescriptionHex.visit"
                          | translate
                      }}
                    </span>
                    <div class="d-flex gap-10 align-visit-date-input">
                      <mat-form-field
                        appearance="outline"
                        class="width-visit-date-input"
                      >
                        <mat-label>{{
                          "medicalHistory.modify.prescriptionHex.visit.dateInput.title"
                            | translate
                        }}</mat-label>
                        <input
                          placeholder="dd.mm.yyyy"
                          matInput
                          [value]="visitAtControl.value | date: 'dd.MM.yyyy'"
                          readonly
                        />
                        <mat-icon matSuffix class="disabled-icon-opacity">
                          calendar_today
                        </mat-icon>
                      </mat-form-field>
                      <mat-form-field
                        appearance="outline"
                        class="width-visit-hours-input"
                      >
                        <mat-label>{{
                          "medicalHistory.modify.prescriptionHex.visit.timeInput.title"
                            | translate
                        }}</mat-label>
                        <input
                          matInput
                          [value]="timeControl.value | date: 'HH:mm'"
                          readonly
                          type="text"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <span class="title">
                      {{
                        "medicalHistory.modify.prescriptionHex.animal.title"
                          | translate
                      }}
                    </span>
                    @if (params.animal.name) {
                      <div class="d-flex gap-10 margin-top-20">
                        <diana-icon
                          class="animal-icon"
                          [name]="params.animal.animalSymbol"
                          color="#bd5b02"
                        ></diana-icon>
                        <span id="spnAnimalTvd" class="align-content-center">{{
                          params.animal.name
                        }}</span>
                        @if (params.animal.tvd) {
                          <span
                            id="spnAnimalTvd"
                            class="align-content-center"
                            >{{ params.animal.tvd }}</span
                          >
                        }
                      </div>
                    }
                  </div>
                  @if (!params.animal.tvd) {
                    <div
                      class="d-flex flex-column width-tvd-auto-complete margin-top-20"
                    >
                      <mat-form-field class="full-width" appearance="outline">
                        <div class="d-flex">
                          <input
                            type="text"
                            matInput
                            formControlName="animalTvdNumber"
                            [matAutocomplete]="auto"
                            (focus)="onFocus()"
                            [placeholder]="
                              'reporting.prescription.autocomplete.tvdNumber.input.placeholder'
                                | translate
                            "
                          />
                          @if (showLoading) {
                            <mat-progress-spinner
                              diameter="25"
                              [color]="'primary'"
                              [mode]="'indeterminate'"
                            >
                            </mat-progress-spinner>
                          }
                        </div>

                        <mat-autocomplete
                          #auto="matAutocomplete"
                          [displayWith]="displayFn"
                        >
                          @for (
                            option of filteredOptions | async;
                            track option
                          ) {
                            <mat-option [value]="option">
                              {{ option.tvdNumber }} {{ option.name }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                      @if (
                        !animalTvdNumberControl.value && !tvdNumberLoadingError
                      ) {
                        <span class="suggestion-color">
                          *{{
                            "reporting.prescription.autocomplete.tvdNumber.info"
                              | translate
                          }}
                        </span>
                      }
                      @if (tvdNumberLoadingError) {
                        <span class="error">
                          *{{ tvdNumberLoadingError }}
                        </span>
                      }
                    </div>
                  }

                  <div class="d-flex flex-column align-center">
                    <span class="height-without-title"> </span>
                    <mat-form-field appearance="outline">
                      <mat-label>{{
                        "medicalHistory.modify.prescriptionHex.animal.animalSpeciesDropdown.title"
                          | translate
                      }}</mat-label>
                      <mat-select
                        formControlName="animalSpecies"
                        id="somAnimalSpecies"
                      >
                        @for (
                          animalSpecies of animalSpeciesList;
                          track animalSpecies
                        ) {
                          <mat-option [value]="animalSpecies">
                            <div>
                              @switch (currentLanguage) {
                                @case (Languages.de) {
                                  <span>
                                    {{ animalSpecies.designationDe }}
                                  </span>
                                }
                                @case (Languages.it) {
                                  <span>
                                    {{ animalSpecies.designationIt }}
                                  </span>
                                }
                                @case (Languages.fr) {
                                  <span>
                                    {{ animalSpecies.designationFr }}
                                  </span>
                                }
                              }
                            </div>
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="d-flex flex-column align-center">
                    <span class="height-without-title"> </span>
                    <mat-form-field
                      appearance="outline"
                      class="width-weight-input"
                    >
                      <mat-label>
                        {{
                          "medicalHistory.modify.prescriptionHex.animal.weightInput.title"
                            | translate
                        }}
                      </mat-label>
                      <input
                        dianaNumberInputCheck
                        [allowNegative]="false"
                        [totalDecimalCases]="2"
                        matInput
                        formControlName="weight"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel
              [expanded]="true"
              class="expanded-details-area"
            >
              <!-- Single treatment form -->
              <div>
                @if (
                  currentPrescriptionDiagnosis &&
                  diagnosisList &&
                  diagnosisList.length > 0
                ) {
                  <diana-diagnosies-with-key
                    [isDiagnosisRequired]="true"
                    [diagnosisList]="diagnosisList"
                    [showTitle]="true"
                    [treatmentPrescriptions]="treatmentPrescriptions"
                    [applicationTypes]="applicationTypes"
                    [servingModes]="servingModes"
                    [hexDiagnoses]="currentPrescriptionDiagnosis"
                    [formVisit]="formGroup"
                    (showCalendarEvent)="showCalendarPage($event)"
                    (typeIsChanged)="handleTypeChange()"
                  >
                  </diana-diagnosies-with-key>
                }
                <div class="padding-top-10" id="confirmationUnsavedChanges">
                  @if (showConfirmation) {
                    <diana-confirmation-input
                      [title]="'general.label.unsavedChanges' | translate"
                      (clickResult)="handleConfirmationPendingChanges($event)"
                    >
                    </diana-confirmation-input>
                  }
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          @if (errorResponse && errorResponse.length > 0) {
            <div class="form-card error background-color-white" id="errorsArea">
              <p>{{ "general.error" | translate }}</p>
              @for (error of errorResponse; track error) {
                <mat-card appearance="outlined">
                  <mat-card-header>
                    <mat-card-title>{{ error.treatmentName }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <ul class="margin-left-20">
                      @if (error.messages && error.messages.length > 0) {
                        <div>
                          @for (
                            errorMessage of error.messages;
                            track errorMessage
                          ) {
                            <li>
                              @switch (errorMessage.source) {
                                @case (PrescriptionSource.UNKNOWN) {
                                  {{ errorMessage.key || "" | translate }}
                                }
                                @case (PrescriptionSource.ISABV) {
                                  {{
                                    "medicalHistory.modify.prescriptionHex.taps.error.isabv"
                                      | translate
                                  }}
                                  @if (currentLanguage === Languages.de) {
                                    <span class="white-space-pre-line">
                                      {{ errorMessage.de || "" | translate }}
                                    </span>
                                  }

                                  @if (currentLanguage === Languages.fr) {
                                    <span class="white-space-pre-line">
                                      {{ errorMessage.fr || "" | translate }}
                                    </span>
                                  }

                                  @if (currentLanguage === Languages.it) {
                                    <span class="white-space-pre-line">
                                      {{ errorMessage.it || "" | translate }}
                                    </span>
                                  }
                                }

                                @case (PrescriptionSource.TAPS) {
                                  {{
                                    "medicalHistory.modify.prescriptionHex.taps.error.taps"
                                      | translate
                                  }}
                                  <span class="white-space-pre-line">
                                    {{
                                      errorMessage.key
                                        ? (errorMessage.key || "" | translate)
                                        : errorMessage.tapsErrorMsg
                                    }}
                                  </span>
                                }
                              }
                            </li>
                          }
                        </div>
                      }
                    </ul>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (datePrescription) {
      <div
        class="d-flex full-size"
        [class.hide-item]="currentPage !== pages.calendarPicker"
      >
        <div class="full-size content">
          <diana-date-picker
            [initialDate]="datePrescription.value"
            (dateSelected)="dateSelected($event)"
          ></diana-date-picker>
        </div>
      </div>
    }
  </div>
  <div mat-dialog-actions>
    @if (currentPage !== pages.calendarPicker) {
      <button
        mat-raised-button
        (click)="onNoClick()"
        id="btnCloseHexPrescriptionModal"
      >
        {{ "general.label.cancel" | translate }}
      </button>
    }
    @if (!showPrescriptionValidation && currentPage !== pages.calendarPicker) {
      <button
        mat-raised-button
        color="primary"
        (click)="showPrescription()"
        id="btnShowPrescription"
      >
        {{
          "medicalHistory.modify.prescriptionHex.button.openPrescriptionConfiguration.label"
            | translate
        }}
      </button>
    }
    @if (showPrescriptionValidation && currentPage !== pages.calendarPicker) {
      <div>
        @if (
          treatmentPrescriptions &&
          treatmentPrescriptions.length > 0 &&
          treatmentPrescriptions[0].isabvState !==
            PrescriptionStatus.CANCELED &&
          treatmentPrescriptions[0].tapsState !== PrescriptionStatus.CANCELED &&
          treatmentPrescriptions[0].isabvState !== PrescriptionStatus.RESENT &&
          treatmentPrescriptions[0].tapsState !== PrescriptionStatus.RESENT
        ) {
          <div class="margin-left-10">
            <button
              mat-raised-button
              color="primary"
              [disabled]="
                checkFormValidation(false) || !animalSpeciesControl.value
              "
              dianaPreventDoubleClick
              id="btnSavePrescription"
              (click)="saveAndClose(false)"
            >
              {{ "general.label.save" | translate }}
            </button>
            <button
              mat-raised-button
              color="primary"
              [disabled]="
                checkFormValidation(true) ||
                (isOnlyDeliveryOnStock === false
                  ? !animalTvdNumberControl.value?.tvdNumber &&
                    !params.animal.tvd
                  : false) ||
                !animalSpeciesControl.value
              "
              dianaPreventDoubleClick
              (click)="saveAndClose(true)"
            >
              {{
                "medicalHistory.modify.prescriptionHex.button.openPrescriptionConfiguration.label"
                  | translate
              }}
            </button>
            @if (
              showDeleteDeactivateButtonText() &&
              params.openFromPrescriptionReport
            ) {
              <button
                mat-raised-button
                color="primary"
                (click)="deleteOrDeactivate()"
                dianaPreventDoubleClick
              >
                {{ showDeleteDeactivateButtonText() || "" | translate }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<ng-template
  #cancelIcon
  let-value="value"
  let-PrescriptionStatus="PrescriptionStatus"
>
  @if (
    value.isabvState === PrescriptionStatus.CANCELED ||
    value.tapsState === PrescriptionStatus.CANCELED ||
    value.isabvState === PrescriptionStatus.RESENT ||
    value.tapsState === PrescriptionStatus.RESENT
  ) {
    <mat-icon> cancel </mat-icon>
  }
</ng-template>
